var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box1 d-pad-30"},[_c('ValidationObserver',{ref:"observer",staticClass:"form-large",attrs:{"tag":"form"},on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var invalid = ref.invalid;
return [_vm._t("default",null,{"formData":_vm.formData})]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }